export default __webpack_public_path__ + "static/top_10_2015-77276f3249b3b185162784b8eb50f6aa.png";